import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { BaseComponent } from '@macs-frontend/core';
import { ListsUrls } from '@macs-frontend/core/utils/consts';
import { Store } from '@ngrx/store';
import { FormControlState, SetValueAction } from 'ngrx-forms';
import {
  ClientStatuses,
  dateValueConverter,
  SupplierStatuses,
  UserStatuses,
} from '@macs-frontend/features/shared';
import { BaseUser } from '@macs-frontend/features/shared/models/user.model';

interface TableFilterDropdownCfg {
  placeholder: string | undefined;
  labelKey?: 'name';
  labelCallback?: (option: any) => string;
  getOptionsParams: Record<string, any>;
  url: string | undefined;
  optionLabelFn: (option: any) => string;
}

type TableFilterDropdownType = 'client' | 'user' | 'supplier';

const defaultCfg: TableFilterDropdownCfg = {
  placeholder: undefined,
  labelKey: undefined,
  labelCallback: undefined,
  getOptionsParams: {},
  url: undefined,
  optionLabelFn: (option: any) => option.name,
};

const cfg: Record<TableFilterDropdownType, TableFilterDropdownCfg> = {
  client: {
    ...defaultCfg,
    ...{
      placeholder: 'Client name',
      labelKey: 'name',
      getOptionsParams: { status: ClientStatuses.ACTIVE },
      url: ListsUrls.Clients,
    },
  },
  user: {
    ...defaultCfg,
    ...{
      placeholder: 'Use name',
      labelCallback: (user: BaseUser) => user.firstName + ' ' + user.lastName,
      getOptionsParams: { status: UserStatuses.ACTIVE },
      url: ListsUrls.Users,
      optionLabelFn: (user: BaseUser) => user.firstName + ' ' + user.lastName,
    },
  },
  supplier: {
    ...defaultCfg,
    ...{
      placeholder: 'Supplier name',
      labelKey: 'name',
      getOptionsParams: { status: SupplierStatuses.ACTIVE },
      url: ListsUrls.Suppliers,
    },
  },
};

@Component({
  selector: 'md-table-filter-dropdown',
  templateUrl: 'table-filter-dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['table-filter-dropdown.component.scss'],
})
export class TableFilterDropdownComponent extends BaseComponent {
  readonly listsUrls = ListsUrls;
  readonly clientStatuses = ClientStatuses;

  @Output() selected = new EventEmitter();
  // @ts-expect-error
  @Input() ngrxFormControl: FormControlState<any>;

  @Input() type: TableFilterDropdownType = 'client';

  @Input() boxed = true;

  show = false;
  readonly dateValueConverter = dateValueConverter;

  constructor(readonly cdr: ChangeDetectorRef, readonly store$: Store) {
    super();
    // makeSelectable(this, { cdr, store$ });
  }

  onClearClick() {
    this.store$.dispatch(new SetValueAction(this.ngrxFormControl.id, null));
    this.selected.emit();
    this.cdr.markForCheck();
  }

  emitSelected() {
    this.selected.emit();
  }

  get cfg(): TableFilterDropdownCfg {
    return cfg[this.type];
  }

  get valueKey() {
    return this.boxed ? undefined : 'uuid';
  }
}
